import { getTimeWithTimeZone } from 'utility/general';
import { GET_DOWNLOAD_DOCUMENT } from 'store/key';
import { useDispatch } from 'react-redux';

const useDocumentLogData = ({ documentLog = [] }) => {
    const dispatch = useDispatch();
    const getDownloadDocument = (item) => {
        dispatch({
            type: GET_DOWNLOAD_DOCUMENT,
            payload: {
                data: {
                    id: item.fileId,
                    type: item.downloadType,
                }
            },
        });
    };
    // const row = [
    //     {
    //         id: moment(Date.now() - 100031).format('YYYY-MM-DD HH:mm:ss'),
    //         user: 'System',
    //         type: 'Research Protocol',
    //         name: 'test.txt',
    //     },
    //     {
    //         id: moment(Date.now() - 10031).format('YYYY-MM-DD HH:mm:ss'),
    //         user: 'KEYPI 2 HKWC',
    //         type: 'Research Protocol',
    //         name: 'Ha virtual background zoom',
    //     },
    //     {
    //         id: moment(Date.now() - 1000312).format('YYYY-MM-DD HH:mm:ss'),
    //         user: 'System',
    //         type: 'Subject Informed Consent',
    //         name: 'test.txt',
    //     },
    //     {
    //         id: moment(Date.now() - 120031).format('YYYY-MM-DD HH:mm:ss'),
    //         user: 'System',
    //         type: 'Other Documents',
    //         name: '_WON-2020-6-4.txt',
    //     },
    // ];

    const rawColumn = [
        { field: 'documentType', headerName: 'Document Type', width: 200 },
        {
            field: 'fileName', headerName: 'File Name', width: 300,
            valueGetter: (params) => {
                return <div
                    onClick={ () => getDownloadDocument(params.row)}
                    style={{ color: 'blue', cursor: 'pointer' }}>
                    {params.value }
                </div>
            }
        },
        {
            field: 'decisionDate',
            headerName: 'Decision Date',
            width: 150,
            valueGetter: (params) => {
                if (!params.value) {
                    return '-';
                }

                return getTimeWithTimeZone(params.value).format('YYYY-MM-DD');
            },
        },
        // { field: 'createdByFullName', headerName: 'Created By', width: 150 },
        
        
    ];

    return { columns: rawColumn, rawColumn: rawColumn, rows: documentLog };
};

export default useDocumentLogData;
